export enum MoveStates {
  initial = 'initial',
  movedIn = 'movedIn',
  movedOut = 'movedOut',
}

export enum PostStatus {
  initial = 'initial',
  deleted = 'deleted',
  archived = 'archived',
}

export enum TopicStatus {
  initial = 'initial',
  deleted = 'deleted',
}

export enum DragTypes {
  column = 'column',
  topics = 'topics',
  pinnedPosts = 'pinnedPosts',
  posts = 'posts',
  mixed = 'mixed',
}

export const UNORGANIZED_TOPIC_ID = 'unorganized-topic-id';
export const LOCAL_TOPIC_ID_PREFIX = 'local-topic-id:';
